import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import AppLayout from "../components/feature/AppLayout";
import Home from "../pages/home/page";
import Inventario from "../pages/inventario/page";
import Movimientos from "../pages/movimientos/page";
import Documentos from "../pages/documentos/page";
import NuevoDocumento from "../pages/documentos/nuevo/page";
import Reportes from "../pages/reportes/page";
import NuevaCompra from "../pages/compras/nueva/page";
import NuevaVenta from "../pages/ventas/nueva/page";
import NuevoGasto from "../pages/gastos/nuevo/page";
import NuevaDevolucion from "../pages/devoluciones/nueva/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "inventario", element: <Inventario /> },
      { path: "movimientos", element: <Movimientos /> },
      { path: "documentos", element: <Documentos /> },
      { path: "documentos/nuevo", element: <NuevoDocumento /> },
      { path: "reportes", element: <Reportes /> },
      { path: "compras/nueva", element: <NuevaCompra /> },
      { path: "ventas/nueva", element: <NuevaVenta /> },
      { path: "gastos/nuevo", element: <NuevoGasto /> },
      { path: "devoluciones/nueva", element: <NuevaDevolucion /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;